/* eslint-disable */

// JS /examencheck-resultaat

import $ from "jquery";

export class ExamencheckResultaat {

  constructor() {
    self = this;


//Redirect user if url has no parameters
    if (!urlHasParams()) {
      if (document.referrer === window.location.href) {
        window.location.replace(window.location.origin);
      } else {
        window.location.replace(document.referrer);
      }
    }

    //Function that returns true or false if the url has parameters
    function urlHasParams(url = window.location.href) {
      return url.includes('?');
    }

//Function that returns all url parameters as an Object
    function getParams(url = window.location.href) {
      let params = [];

      new URL(url).searchParams.forEach(function (val, key) {
        if (params[key] !== undefined) {
          if (!Array.isArray(params[key])) {
            params[key] = [params[key]];
          }
          params[key].push(val);
        } else {
          params[key] = val;
        }
      });

      return params;

    }


//Loop over url parameters
    for (const [key, value] of Object.entries(getParams())) {
      if (key === 'vak') {
        $("#vak").text(value);

        $(".advice-text li").each(function () {
          let text = $(this).html();
          $(this).html(text.replace("%vak%", value));
        });

        $(".advice-text li").each(function () {
          let text = $(this).html();
          $(this).html(text.replace("%vakUrl%", value));
        });

        //break;
      }
      if (key === 'niveau') {
        $("#niveau").text(value);

        $(".advice-text li").each(function () {
          let text = $(this).html();
          $(this).html(text.replace("%niveau%", value));
        });
        $(".advice-text li").each(function () {
          let text = $(this).html();
          $(this).html(text.replace("%niveauUrl%", value));
        });

      }
    }

    let src;
    let newStr;
    src = $('.ext-link').attr('href');
    newStr = src.replace('-', '+');
    $('.ext-link').attr('href', newStr);

    let srcSummary;
    let newStrSummary;
    srcSummary = $('.ext-summary').attr('href');
    newStrSummary = srcSummary.replace('-tl', '');
    $('.ext-summary').attr('href', newStrSummary);
  }
}
